module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeBAMAAADJHrORAAAAJ1BMVEVHcEx93ll921nl/+V821h921iU+2d93VqD3mB921l921l821h82lgFQrd5AAAADHRSTlMANZoB8K0FVRvOfMeE1I5KAAAAj0lEQVQY02NgoB5gn7IdmcsWc+bMAiR+6pkzZ06gSp85jioN5rcLw6VB6pPOnBSASQPNY9Y5c8YRJn3IgIEDSB0RgEorAx0Boh3h0gyMIMYRUZg0A/OcMzAAkmZgEIHzlcHuYPRBkUYoUIY61NAHRRqmQBnuE7AChDREgTJSSACtQJZmYOgKEkALSwMqxQkAN89pyeG7nl0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/lib/components/LessonPath/static/img/icon-green-right.png
// module id = 667
// module chunks = 1